import { gsap } from 'gsap'

import Link from './../animations/Link'
import Component from '../classes/Component'

import { mapEach } from '../utils/dom'

export default class Navigation extends Component {
  constructor ({ classes, element, elements }) {
    super({
      classes,
      element,
      elements
    })

    // this.links = mapEach(this.elements.links, element => {
    //   return new Link({
    //     element
    //   })
    // })
  }

  /**
   * Animations.
   */
  show (slug) {
    this.elements.items.forEach( item => {
      const value = item.querySelector('a').getAttribute("href");

      if (slug === value) {
        item.classList.add(this.classes.linksActive)
      }
    })
  }

  hide () {
    this.elements.items.forEach( item => {
      item.classList.remove(this.classes.linksActive)
    })
  }



  /**
   * Events.
   */
  onNavigationStart () {
    this.hide()
  }

  onNavigationEnd (slug) {
    this.show(slug)
  }

}
